module.exports = __webpack_public_path__ + "static/media/tavernello.72503731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tavernello.jpg
// module id = 815
// module chunks = 0